import Swiper from 'swiper/bundle';

var sliderContent = document.querySelector(".slider-banner-container")

if (sliderContent) {
	new Swiper(sliderContent, {
        slidesPerView: 1,
        centeredSlides: true,
        fade: 'true',
        enabled: 'true',
        grabCursor: 'true',


        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
        },

        pagination: {
            el: ".banner__pagination",
            dynamicBullets: false,
            clickable: true,
        },

        navigation: {
            nextEl: sliderContent.querySelector(".banner__btn-next"),
            prevEl: sliderContent.querySelector(".banner__btn-prev"),
        },

        breakpoints:{
            1024: {
                slidesPerView: 1,
            },
        },
    })
}
